module.exports = __webpack_public_path__ + "static/img/manual-53.d94c020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-53.png
// module id = N+p4
// module chunks = 4